import { createSlice } from "@reduxjs/toolkit"

import { OnboardingFlow, OnboardingStep } from "#/shared/types/onboarding"

type OnboardingState = {
  flow: OnboardingFlow
  step: OnboardingStep
}

const initialState: OnboardingState = {
  flow: OnboardingFlow.SIGN_IN,
  step: OnboardingStep.AUTHORIZATION,
}

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setOnboardingFlow: (
      immerState,
      { payload }: { payload: OnboardingFlow },
    ) => {
      immerState.flow = payload
    },
    setOnboardingStep: (
      immerState,
      { payload }: { payload: OnboardingStep },
    ) => {
      immerState.step = payload
    },
    resetOnboardingFlow: () => initialState,
  },
})

export const { setOnboardingFlow, setOnboardingStep, resetOnboardingFlow } =
  onboardingSlice.actions

export default onboardingSlice.reducer
